import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Store, createSelector } from '@ngrx/store';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

import { CancelPayLinkDialogActions } from './cancel-pay-link-dialog.actions';
import { cancelPayLinkDialogFeature } from './cancel-pay-link-dialog.feature';

@Component({
    selector: 'app-cancel-pay-link-dialog',
    standalone: true,
    imports: [ CommonModule, ButtonModule, DialogModule ],
    templateUrl: './cancel-pay-link-dialog.component.html',
})
export class CancelPayLinkDialogComponent {
    actions = CancelPayLinkDialogActions;

    viewModel$ = this.store.select(createSelector({
        target: cancelPayLinkDialogFeature.selectTarget,
        amount: createSelector(
            cancelPayLinkDialogFeature.selectTarget,
            (target) => (target?.amountMinor ?? 0) / 100,
        ),
    }));

    constructor(public store: Store) {}
}
